(() => {
  const shortcut = document.querySelector('[data-cv-sticky-preview]');
  const heroForm = document.getElementById('store-preview-form');
  const heroInput = heroForm?.querySelector('input[name="url"]');
  if (!shortcut || !heroInput) return;
  const input = shortcut.querySelector('input');
  shortcut.querySelector('button').setAttribute('aria-label', 'Preview my store');
  shortcut.addEventListener('submit', event => {
    event.preventDefault();
    const submit = heroForm.querySelector('[data-cvt-submit]');
    if (submit?.disabled) return;
    const value = input.value.trim();
    if (!value) { input.focus(); return; }
    heroInput.value = value;
    heroInput.dispatchEvent(new Event('input', { bubbles: true }));
    heroInput.dispatchEvent(new Event('change', { bubbles: true }));
    heroForm.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    heroInput.focus({ preventScroll: true });
    heroForm.requestSubmit(submit || undefined);
  });
})();
